import { Text } from '~components/Typography';
import { abbreviateNumber } from '~shared/utils/number';

import { Stat, Stats } from './styles';

type Props = {
	items: {
		label: string;
		value: number;
	}[];
};

export const ProfileCardStats = ({ items }: Props) => {
	return (
		<Stats>
			{items.map(({ label, value }) => (
				<Stat key={label}>
					<Text size="L" as="span">
						{abbreviateNumber(value)}
					</Text>
					<Text size="S" as="span" color="grey-52-solid">
						{label}
					</Text>
				</Stat>
			))}
		</Stats>
	);
};
